import type { ValueOrCondition } from '@unifyapps/defs/types/conditionalValueFilters';
import { getIconFromRegistry } from '@unifyapps/icons/utils/getIconFromRegistry';
import type { ComponentType, SVGProps } from 'react';
import { getConditionalPropertyValue } from './conditionalValues';
import { createCustomIcon } from './createCustomIcon';

export const getInlineSvgIcon = (
  value: ValueOrCondition<string> | undefined,
): ComponentType<SVGProps<SVGSVGElement>> | undefined => {
  const iconName = getConditionalPropertyValue({ value });
  if (!iconName) return undefined;
  return getIconFromRegistry(iconName, createCustomIcon(iconName));
};

export const getInlineSvgIconByName = (
  iconName: string | undefined,
): ComponentType<SVGProps<SVGSVGElement>> | undefined => {
  if (!iconName) return undefined;
  return getIconFromRegistry(iconName, createCustomIcon(iconName));
};
